import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'

/**
 * Determines whether the participant is spotlighted or dominant speaker during spotlight
 * @param state The Redux state
 */

const autoSpotlight = (state: State) => state.syncUi.autoSpotlight
const presenterId = (state: State, props) => props.presenter.BTID
const focusOn = (state: State) => state.syncUi.focusOn
const dominantSpeaker = (state: State) => state.syncUi.dominantSpeaker

export function isParticipantNotSpotlighted(autoSpotlight: boolean, presenterId: string,
  focusedOn: string | null, dominantSpeaker: string | null): boolean {

  if(!focusedOn && !dominantSpeaker) return false

  if (!autoSpotlight && presenterId !== focusedOn) return true

  if (autoSpotlight && presenterId !== dominantSpeaker) return true

  return false
}

export default createSelector(
  [autoSpotlight, presenterId, focusOn, dominantSpeaker],
  (autoSpotlight, presenterId, focusedOn, dominantSpeaker): boolean =>
    isParticipantNotSpotlighted(
      autoSpotlight,
      presenterId,
      focusedOn,
      dominantSpeaker
    )
)